import { IAppState } from '../../../AppModulesWrapper';

export function selectIsIdentificationNeeded(state: IAppState): boolean {
  const {
    publishAvailable: { isIdentificationNeeded },
  } = state.servicePickerWidget;

  return isIdentificationNeeded;
}
